export const cohortIds = [
  '0a3a332c-b4da-4f93-a0c6-478c8ee1435f',
  'db678dec-d8f3-45ed-a3a9-ba8793a2d5fd',
  '06817e98-afdd-414b-a87f-fabcec8e3c16',
  '0654d90e-d7e1-443c-b7db-37dffe72c67e',
];
